<template>
 <!-- EXAMPLE USAGE:
  <BaseDropDown
    v-on:show-settings="showSettings = true"
    v-on:remove-option="$emit('remove-option', option)"
    v-on:clone-option="$emit('clone-option', option)"
    v-bind:items="[
      {
        event: 'show-settings',
        label: 'Option settings',
        icon: 'heroicons/outline/cog',
      },
      {
        event: 'clone-option',
        args: option,
        label: 'Clone option',
        icon: 'heroicons/outline/duplicate',
      },
      {
        label: 'Survey results',
        route: { path: '/results/' + survey.id },
        icon: 'heroicons/outline/chart-square-bar',
      },
    ]"
  >
    <template v-slot:button>
      <div class="items-center flex">
        <span
          class="bg-gray-200 p-2 border border-solid hover:border-gray-300 mr-5 text-gray-400 hover:text-gray-500 hover:bg-gray-100 inline-flex items-center justify-center rounded-full"
        >
          <svg-icon icon="heroicons/outline/dots-horizontal"></svg-icon>
        </span>
      </div>
    </template>

    <template v-slot:header>
      <div class="text-sm font-semibold py-2 px-4">Insert Username</div>
      <div class="border border-solid border-gray-200"></div>
    </template>
  </BaseDropDown>
-->

  <!-- Uses clickaway mixin from https://github.com/simplesmiler/vue-clickaway -->
  <div v-on-clickaway="closeMenu">
    <!-- Default Dropdown button -->
    <div
      class="cursor-pointer"
      v-on:click="toggleDropdown($event)"
      ref="btnDropdownRef"
    >
      <slot name="button">
        <div class="items-center flex">
          <span
            class="w-8 h-8 text-sm hover:bg-gray-100 inline-flex items-center justify-center rounded-full"
          >
            <svg-icon
              icon="heroicons/outline/dots-vertical"
              class="h-6 w-6 text-gray-400 hover:text-gray-500"
            ></svg-icon>
          </span>
        </div>
      </slot>
    </div>

    <!-- START DROPDOWN PANEL -->
    <transition name="fade">
      <div
        ref="popoverDropdownRef"
        class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg mt-1 p-1"
        v-show="menuOpen"
        style="border: 1px solid #e3e3e3"
      >
        <!-- START HEADER -->
        <slot name="header"></slot>

        <!-- START MENU -->
        <div v-for="(item, index) in items" :key="index" class="flex flex-col justify-center items-center">

          <div
            v-if="item.event != null"
             class="cursor-pointer text-sm py-2 px-2 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800 hover:text-gray-600 hover:bg-gray-100 hover:no-underline"          @click="
              emitEvent(item);
              menuOpen = false;
            "
          >
            <div class="flex flex-row justify-start align-middle">
              <svg-icon
                v-if="item.icon"
                :icon="item.icon"
                class="h-6 w-6"
              ></svg-icon>
              <div class="ml-1">{{ item.label }}</div>
            </div>
          </div>

          <router-link
            v-else
            :to="item.route"
            class="text-sm py-2 px-2 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800 hover:text-gray-600 hover:bg-gray-100 hover:no-underline"
          >
            <div class="flex flex-row justify-start align-middle">
              <svg-icon v-if="item.icon" :icon="item.icon" class="h-6 w-6"></svg-icon>
              <div class="ml-1">{{ item.label }}</div>
            </div>
          </router-link>

        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import Popper from "popper.js";
import { mixin as clickaway } from "vue-clickaway";
import SvgIcon from "@/components/SvgIcon.vue";
//import EventBus from "@/event-bus.js";

export default {
  components: { SvgIcon },
  mixins: [clickaway],
  data() {
    return {
      menuOpen: false,
      popper: null,
    };
  },
  props: {
    items: {
      required: true
    },
    placement: {
      type: String,
      required: false,
      default: 'bottom-end'
    }
  },
  computed: {},
  methods: {
    toggleDropdown: function(event) {
      event.preventDefault();
      if (this.menuOpen) {
        this.closeMenu();
        
      } else {
        this.menuOpen = true;
        this.popper = new Popper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: this.placement,
        });
      }
    },
    emitEvent(item) {
      this.$emit(item.event, item.args);
    },
    closeMenu: function() {
      this.menuOpen = false;
      //this.popper.destroy();
    },
    escapeKeyListener: function(evt) {
      if (evt.keyCode === 27 && this.menuOpen) {
        this.closeMenu();
      }
    },
  },
  created: function() {
    document.addEventListener("keyup", this.escapeKeyListener);
  },
  destroyed: function() {
    if (this.popper != null){
      this.popper.destroy();
    }
    document.removeEventListener("keyup", this.escapeKeyListener);
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: scale(0.5);
}
</style>
